import { LatLngId, TargomoClient } from '@targomo/core';
import { PolygonGeoJsonOptions } from '@targomo/core/typings/api/payload';
import { FeatureCollection, MultiPolygon } from '@turf/helpers';
import { getModule } from 'vuex-module-decorators';
import { MapStore } from '@/store/map';
import store from '@/store';
import { projectDefaultIsochrone } from '@/isochrones';
import axios from 'axios';

const mapStore = getModule(MapStore, store);

const targomoClient = new TargomoClient('westcentraleurope', process.env.VUE_APP_TARGOMO);

const GetPolygons = (sources: LatLngId[], options: PolygonGeoJsonOptions): Promise<FeatureCollection<MultiPolygon>> => {
  return targomoClient.polygons.fetch(sources, options);
};
const client = new TargomoClient('westcentraleurope', process.env.VUE_APP_TARGOMO);

const statsConfig = (time: number, travelType: 'walk' | 'car' | 'bike' | 'transit') => {
  const stats: {
    maxEdgeWeight: number;
    travelType: 'walk' | 'car' | 'bike' | 'transit';
    statisticsGroup: number;
    statistics: { id: number; name: string }[];
  } = {
    maxEdgeWeight: time,
    travelType: travelType,
    statisticsGroup: 123,
    statistics: [{ id: 0, name: 'test' }]
  };
  return stats;
};

const stats = (time: number, travelType: 'walk' | 'car' | 'bike' | 'transit') => {
  const stats: {
    statisticsGroup: number;
    statistics: { id: number; name: string; label: string; colors: Array<any> }[];
    maxEdgeWeight: number;
    colors: Array<any>;
    travelType: 'walk' | 'car' | 'bike' | 'transit';
  } = {
    statisticsGroup: 123,
    statistics: [
      {
        id: 29,
        name: 'Diploma',
        label: 'Diploma',
        colors: [
          'rgba(26,152,80,0.25)',
          'rgba(145,207,96,0.25)',
          'rgba(217,239,139,0.25)',
          'rgba(254,224,139,0.25)',
          'rgba(252,141,89,0.25)',
          'rgba(215,48,39,0.25)'
        ]
      },
      {
        id: 30,
        name: 'Bepc',
        label: 'Bepc',
        colors: [
          'rgba(26,152,80,0.25)',
          'rgba(145,207,96,0.25)',
          'rgba(217,239,139,0.25)',
          'rgba(254,224,139,0.25)',
          'rgba(252,141,89,0.25)',
          'rgba(215,48,39,0.25)'
        ]
      },
      {
        id: 31,
        name: 'Cap/Bep',
        label: 'Cap/Bep',
        colors: [
          'rgba(26,152,80,0.25)',
          'rgba(145,207,96,0.25)',
          'rgba(217,239,139,0.25)',
          'rgba(254,224,139,0.25)',
          'rgba(252,141,89,0.25)',
          'rgba(215,48,39,0.25)'
        ]
      },
      {
        id: 32,
        name: 'Bac',
        label: 'Bac',
        colors: [
          'rgba(26,152,80,0.25)',
          'rgba(145,207,96,0.25)',
          'rgba(217,239,139,0.25)',
          'rgba(254,224,139,0.25)',
          'rgba(252,141,89,0.25)',
          'rgba(215,48,39,0.25)'
        ]
      },
      {
        id: 33,
        name: 'Bac +2',
        label: 'Bac +2',
        colors: [
          'rgba(26,152,80,0.25)',
          'rgba(145,207,96,0.25)',
          'rgba(217,239,139,0.25)',
          'rgba(254,224,139,0.25)',
          'rgba(252,141,89,0.25)',
          'rgba(215,48,39,0.25)'
        ]
      },
      {
        id: 34,
        name: 'Bac +3/4',
        label: 'Bac +3/4',
        colors: [
          'rgba(26,152,80,0.25)',
          'rgba(145,207,96,0.25)',
          'rgba(217,239,139,0.25)',
          'rgba(254,224,139,0.25)',
          'rgba(252,141,89,0.25)',
          'rgba(215,48,39,0.25)'
        ]
      },
      {
        id: 35,
        name: 'Bac +5',
        label: 'Bac +5',
        colors: [
          'rgba(26,152,80,0.25)',
          'rgba(145,207,96,0.25)',
          'rgba(217,239,139,0.25)',
          'rgba(254,224,139,0.25)',
          'rgba(252,141,89,0.25)',
          'rgba(215,48,39,0.25)'
        ]
      }
    ],
    maxEdgeWeight: time,
    colors: ['#d73027', '#fc8d59', '#fee08b', '#d9ef8b', '#91cf60', '#1a9850'].reverse(),
    travelType: travelType
  };
  return stats;
};

const getData = async (coord: any[], time: number, travelType: 'walk' | 'car' | 'bike' | 'transit') => {
  const sources = [Object.assign({}, { lng: coord[0], lat: coord[1], id: 'Marker1' })];
  return await Promise.all([
    client.statistics.dependent(sources, stats(time, travelType)),
    client.statistics.travelTimes(sources, statsConfig(time, travelType))
  ]);
};

const getDataMap = async () => {
  const populationMeta = await client.statistics.metadataKey(123, { id: 0, name: 'test' });
  const tileRoute = await client.statistics.tileRoute(123, [{ id: 0, name: 'test' }]);
  return { populationMeta, tileRoute };
};

const statsPotentialDemand = (time: any, travelType: any) => ({
  statisticsGroup: 123,
  statistics: [
    {
      id: 0,
      name: 'Total',
      label: 'Total'
    },
    {
      id: 2,
      name: '0 - 14 ans',
      label: '0 - 14 ans'
    },
    {
      id: 4,
      name: '15 - 29 ans',
      label: '15 - 29 ans'
    },
    {
      id: 7,
      name: '30 - 44 ans',
      label: '30 - 44 ans'
    },
    {
      id: 8,
      name: '45 - 59 ans',
      label: '45 - 59 ans'
    },
    {
      id: 9,
      name: '60 - 74 ans',
      label: '60 - 74 ans'
    },
    {
      id: 10,
      name: '75+ ans',
      label: '75+ ans'
    }
  ],
  maxEdgeWeight: time,
  travelType
});

const getPotentialDemand = async (): Promise<any> => {
  const [lng, lat] = mapStore.lastMarkerCoord;
  if (lng && lat) {
    return new Promise(resolve => {
      const sources = [{ lng, lat, id: 'Marker1' }];
      client.statistics
        .dependent(sources, statsPotentialDemand(mapStore.selectedTime, mapStore.travelType))
        .then(({ statistics }: any) => {
          resolve(
            Object.entries(statistics).reduce((acc: any, [key, value]: any) => {
              return {
                ...acc,
                [key]: value.total.toFixed()
              };
            }, {})
          );
        });
    });
  } else {
    return new Promise(resolve => {
      axios
        .post(
          'https://api.targomo.com/statistics/values/geometry?serviceUrl=https://api.targomo.com/westcentraleurope/',
          {
            serviceKey: process.env.VUE_APP_TARGOMO,
            serviceUrl: 'https://api.targomo.com/westcentraleurope/',
            statisticIds: [0, 2, 4, 7, 8, 9, 10],
            statisticGroupId: 123,
            intersectionGeometry: {
              crs: 4326,
              data: JSON.stringify(projectDefaultIsochrone().original.features[0].geometry)
            }
          }
        )
        .then(({ data }: any) => {
          const fields = ['0-SUM', '2-SUM', '4-SUM', '7-SUM', '8-SUM', '9-SUM', '10-SUM'];
          const labelMapper: any = {
            '0-SUM': 'Total',
            '2-SUM': '0 - 14 ans',
            '4-SUM': '15 - 29 ans',
            '7-SUM': '30 - 44 ans',
            '8-SUM': '45 - 59 ans',
            '9-SUM': '60 - 74 ans',
            '10-SUM': '75+ ans'
          };
          const sortedResponse = Object.entries(data).sort(([a], [b]) => fields.indexOf(a) - fields.indexOf(b));
          resolve(
            sortedResponse.reduce(
              (acc: any, [key, value]: any) => ({
                ...acc,
                [labelMapper[key]]: value.value.toFixed()
              }),
              {}
            )
          );
        });
    });
  }
};

export default {
  GetPolygons,
  getData,
  getDataMap,
  getPotentialDemand
};
